function isEditablePasteTarget(target: EventTarget | null): target is HTMLElement {
  if (!(target instanceof HTMLElement)) {
    return false;
  }

  const contentEditableRoot = target.closest<HTMLElement>('[contenteditable]');
  const isContentEditable = contentEditableRoot
    ? contentEditableRoot.getAttribute('contenteditable') !== 'false'
    : target.isContentEditable;

  return (
    isContentEditable ||
    target instanceof HTMLInputElement ||
    target instanceof HTMLTextAreaElement ||
    target instanceof HTMLSelectElement
  );
}

export { isEditablePasteTarget };
